import { createRoot } from 'react-dom/client'

import reportWebVitals from 'app/providers/reportWebVitals'
import App from 'app/App'
import 'app/providers/theme/main.css';
const container = document.querySelector('#root') as HTMLElement
const root = createRoot(container)

root.render(<App />)

reportWebVitals()
